let settings = null

const loadSettings = async (hostname, language) => {
	let loaded = null

	if (/localhost/i.test(hostname))
		loaded = await import('./config/local')
	else if (/[.|-]uat[.|-]/i.test(hostname))
		loaded = await import('./config/uat')
	else
		loaded = await import('./config/prod')

	settings = { ...loaded, language }
}

export { settings, loadSettings }